export function setDisponibilidad(state, disponibilidad) {
  state.disponibilidad_S = disponibilidad.disponibilidad_S;
  state.disponibilidad_M = disponibilidad.disponibilidad_M;
  state.disponibilidad_L = disponibilidad.disponibilidad_L;
  state.disponibilidad_XL = disponibilidad.disponibilidad_XL;
  state.disponibilidad_MS = disponibilidad.disponibilidad_MS;
  state.disponibilidad_MM = disponibilidad.disponibilidad_MM;
  state.disponibilidad_ML = disponibilidad.disponibilidad_ML;

  console.log('disponibilidad_S:', state.disponibilidad_S);
 
}

export function setDisponibilidad_S(state, disponibilidad) {
  state.disponibilidad_S = disponibilidad;
}

export function setDisponibilidad_M(state, disponibilidad) {
  state.disponibilidad_M = disponibilidad;
}

export function setDisponibilidad_L(state, disponibilidad) {
  state.disponibilidad_L = disponibilidad;
}

export function setDisponibilidad_XL(state, disponibilidad) {
  state.disponibilidad_XL = disponibilidad;
}

export function setDisponibilidad_MS(state, disponibilidad) {
  state.disponibilidad_MS = disponibilidad;
}

export function setDisponibilidad_MM(state, disponibilidad) {
  state.disponibilidad_MM = disponibilidad;
}

export function setDisponibilidad_ML(state, disponibilidad) {
  state.disponibilidad_ML = disponibilidad;
}

export function setSelecBici(state, bici) {
    switch (bici.talla) {
    case "S":
      const index = state.disponibilidad_S.findIndex((r) => r.id == bici.id);
      if (index != -1) {
        state.disponibilidad_S[index].seleccion = !state.disponibilidad_S[index].seleccion;
      }
      break;
    case "M":
        const index1 = state.disponibilidad_M.findIndex((r) => r.id == bici.id);
      if (index1 != -1) {
        state.disponibilidad_M[index1].seleccion = !state.disponibilidad_M[index1].seleccion;
      }
      break;

    case "L":
        const index2 = state.disponibilidad_L.findIndex((r) => r.id == bici.id);
      if (index2 != -1) {
        state.disponibilidad_L[index2].seleccion = !state.disponibilidad_L[index2].seleccion;
      }
      break;

    case "XL":
        const index3 = state.disponibilidad_XL.findIndex((r) => r.id == bici.id);
      if (index3 != -1) {
        state.disponibilidad_XL[index3].seleccion = !state.disponibilidad_XL[index3].seleccion;
      }
      break;

      case "MS":
        const index6 = state.disponibilidad_MS.findIndex((r) => r.id == bici.id);
          if (index6 != -1) {
            state.disponibilidad_MS[index6].seleccion = !state.disponibilidad_MS[index6].seleccion;
          }
          break;

    case "MM":
    const index4 = state.disponibilidad_MM.findIndex((r) => r.id == bici.id);
      if (index4 != -1) {
        state.disponibilidad_MM[index4].seleccion = !state.disponibilidad_MM[index4].seleccion;
      }
      break;
      
      case "ML":
      const index5 = state.disponibilidad_ML.findIndex((r) => r.id == bici.id);
      if (index5 != -1) {
        state.disponibilidad_ML[index5].seleccion = !state.disponibilidad_ML[index5].seleccion;
      }
      break;  

    default:
      break;
  }
}

export function updateSeleccionadasEditar(state, bicis) {
  
  bicis.forEach(bici => {
    const index = state.disponibilidad_S.findIndex((r) => r.id == bici.id);
    if (index != -1) {
      state.disponibilidad_S[index].seleccion = true;
      state.disponibilidad_S[index].ocupada = false;
    }

    const index1 = state.disponibilidad_M.findIndex((r) => r.id == bici.id);
    if (index1 != -1) {
      state.disponibilidad_M[index1].seleccion = true;
      state.disponibilidad_M[index1].ocupada = false;
    }

    const index2 = state.disponibilidad_L.findIndex((r) => r.id == bici.id);
    if (index2 != -1) {
      state.disponibilidad_L[index2].seleccion = true;
      state.disponibilidad_L[index2].ocupada = false;
    }

    const index3 = state.disponibilidad_XL.findIndex((r) => r.id == bici.id);
    if (index3 != -1) {
      state.disponibilidad_XL[index3].seleccion = true;
      state.disponibilidad_XL[index3].ocupada = false;
    }

    const index6 = state.disponibilidad_MS.findIndex((r) => r.id == bici.id);
    if (index6 != -1) {
      state.disponibilidad_MS[index6].seleccion = true;
      state.disponibilidad_MS[index6].ocupada = false;
    }

    const index4 = state.disponibilidad_MM.findIndex((r) => r.id == bici.id);
    if (index4 != -1) {
      state.disponibilidad_MM[index4].seleccion = true;
      state.disponibilidad_MM[index4].ocupada = false;
    }
       
    const index5 = state.disponibilidad_ML.findIndex((r) => r.id == bici.id);
    if (index5 != -1) {
      state.disponibilidad_ML[index5].seleccion = true;
      state.disponibilidad_ML[index5].ocupada = false;
    }
  });
}
